import { motion } from 'framer-motion';
import { ChevronRight, ChevronDown, ArrowRight } from 'lucide-react';

function Stepper({ active }) {
  const steps = ['Basics', 'Build', 'Configure', 'Review'];
  return (
    <div className="flex items-center justify-center gap-0 py-5 px-6 bg-[#FAFAFA] rounded-2xl mb-4">
      {steps.map((s, i) => (
        <div key={s} className="flex items-center">
          <div className="flex flex-col items-center gap-1">
            <div className={`w-7 h-7 rounded-full flex items-center justify-center text-[10px] font-bold border-2 ${
              i < active ? 'bg-teal-600 border-teal-600 text-white' :
              i === active ? 'bg-white border-teal-600 text-teal-600' :
              'bg-white border-[#E5E7EB] text-[#737373]'
            }`}>{i < active ? '✓' : <span className="w-1.5 h-1.5 rounded-full bg-current" />}</div>
            <span className={`text-[12px] font-body ${i <= active ? 'font-medium text-[#0A0A0A]' : 'text-[#737373]'}`}>{s}</span>
          </div>
          {i < steps.length - 1 && <div className={`w-24 h-[2px] mx-2 mt-[-16px] ${i < active ? 'bg-teal-600' : 'bg-[#E5E7EB]'}`} />}
        </div>
      ))}
    </div>
  );
}

export default function SurveyBasicsScene({ onNext }) {
  return (
    <div data-testid="scene-survey-basics" className="flex flex-col items-center justify-start h-full px-8 pt-3 overflow-y-auto">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="w-full max-w-3xl">
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.1 }}
          className="text-[12px] font-body text-[#737373] mb-2">
          Home <ChevronRight size={12} className="inline" /> Survey <ChevronRight size={12} className="inline" /> <span className="font-medium text-[#0A0A0A]">Create new survey</span>
        </motion.div>
        <h2 className="font-heading font-bold text-2xl text-[#0A0A0A] mb-3">Create New Survey</h2>

        <Stepper active={0} />

        <div className="flex justify-end mb-3">
          <span className="px-3 py-1 rounded border border-[#E5E7EB] text-[12px] font-body text-[#0A0A0A]">Save</span>
        </div>

        <motion.div initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }}
          className="bg-[#FAFAFA] rounded-2xl border border-[#E5E7EB] p-6">
          <h3 className="font-heading font-bold text-base text-[#0A0A0A] mb-1">Basic details</h3>

          <div className="space-y-4 mt-4">
            <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5 }}>
              <label className="text-[13px] font-body font-bold text-[#0A0A0A] mb-1.5 block">Survey title<span className="text-red-500">*</span></label>
              <div className="w-full px-3 py-2.5 rounded-lg border border-[#E5E7EB] bg-white text-sm font-body text-[#0A0A0A]">
                Q4 Patient Satisfaction Survey
              </div>
            </motion.div>

            <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.65 }}>
              <label className="text-[13px] font-body font-bold text-[#0A0A0A] mb-1.5 block">Description</label>
              <div className="w-full px-3 py-3 rounded-lg border border-[#E5E7EB] bg-white text-sm font-body text-[#737373] min-h-[100px]">
                Provide a brief overview of this survey's objectives..
              </div>
            </motion.div>

            <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.8 }}>
              <label className="text-[13px] font-body font-bold text-[#0A0A0A] mb-1.5 block">Purpose<span className="text-red-500">*</span></label>
              <div className="w-full px-3 py-2.5 rounded-lg border border-[#E5E7EB] bg-white text-sm font-body text-[#737373] flex items-center justify-between">
                <span>Select purpose</span>
                <ChevronDown size={16} className="text-[#737373]" />
              </div>
            </motion.div>
          </div>
        </motion.div>

        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.0 }} className="flex justify-center mt-5 mb-4">
          <button onClick={onNext} className="flex items-center gap-2 px-8 py-2.5 rounded-xl bg-teal-600 text-white font-body font-bold text-sm cursor-pointer">
            Next <ArrowRight size={16} />
          </button>
        </motion.div>
      </motion.div>
    </div>
  );
}
